import validate from 'validate.js';

const presenceContent = function(value, options) {
  value = (value || '').replace(/<[^>]+>/g, '').trim();
  return validate.validators.presence(value, options);
};

export default presenceContent;



// WEBPACK FOOTER //
// ./src/utilites/validate/presenceContent.js